var ServerPickerGroupViewModel, ServerPickerServerViewModel, ServerPickerViewModel;

ServerPickerGroupViewModel = (function() {
  function ServerPickerGroupViewModel(group, options) {
    var _doesntMatter;
    this.rawGroup = group;
    this.state = ko.observable('unchecked');
    this.isChecked = ko.computed((function(_this) {
      return function() {
        return _this.state() === 'checked';
      };
    })(this));
    this.isIndeterminate = ko.computed((function(_this) {
      return function() {
        return _this.state() === 'indeterminate';
      };
    })(this));
    this.selectable = ko.computed((function(_this) {
      return function() {
        return _this.state() !== 'notSelectable';
      };
    })(this));
    this.rawServers = ko.asObservableArray(group.servers != null ? group.servers : []);
    this.allRawGroups = ko.asObservableArray(group.groups != null ? group.groups : []);
    this.rawGroups = ko.computed((function(_this) {
      return function() {
        return _this.allRawGroups().filter(options.shouldShowGroup);
      };
    })(this));
    this.groups = ko.computed((function(_this) {
      return function() {
        return _this.rawGroups().map(function(g) {
          return new ServerPickerGroupViewModel(g, options);
        });
      };
    })(this));
    this.selectableGroups = ko.computed((function(_this) {
      return function() {
        return _this.groups().filter(function(g) {
          return g.state() !== 'notSelectable';
        });
      };
    })(this));
    this.servers = ko.computed((function(_this) {
      return function() {
        return _this.rawServers().map(function(s) {
          return new ServerPickerServerViewModel(s, options);
        });
      };
    })(this));
    this.selectableServers = ko.computed((function(_this) {
      return function() {
        return _this.servers().filter(function(s) {
          return s.selectable();
        });
      };
    })(this));
    this.setServersAndGroups = function(checked) {
      this.selectableGroups().forEach((function(_this) {
        return function(g) {
          return g.setServersAndGroups(checked);
        };
      })(this));
      return this.servers().forEach((function(_this) {
        return function(s) {
          if (s.selectable()) {
            return s.isChecked(checked);
          }
        };
      })(this));
    };
    this.clickHandler = (function(_this) {
      return function(group, event) {
        var checkbox, checked;
        checkbox = $(event.target);
        checked = checkbox.prop('checked');
        _this.setServersAndGroups(checked);
        return true;
      };
    })(this);
    this.title = ko.computed((function(_this) {
      return function() {
        if (_this.selectable()) {
          return options.getGroupTitle(_this.rawGroup);
        } else {
          return 'Groups that have no decendent server are not selectable.';
        }
      };
    })(this));
    this.allServers = ko.computed((function(_this) {
      return function() {
        var servers;
        servers = _this.selectableServers();
        _this.selectableGroups().forEach(function(g) {
          servers = servers.concat(g.servers());
        });
        return servers;
      };
    })(this));
    _doesntMatter = ko.computed((function(_this) {
      return function() {
        var checkedGroups, indeterminateGroups, selectableGroups, selectableServers, selectedServers, uncheckedGroups;
        if (!options.multiSelect()) {
          return;
        }
        checkedGroups = [];
        indeterminateGroups = [];
        uncheckedGroups = [];
        selectableGroups = _this.selectableGroups();
        selectableServers = _this.selectableServers();
        selectedServers = selectableServers.filter(function(s) {
          return s.isChecked();
        });
        selectableGroups.forEach(function(g) {
          if (g.state.peek() === 'checked') {
            return checkedGroups.push(g);
          } else if (g.state.peek() === 'indeterminate') {
            return indeterminateGroups.push(g);
          } else {
            return uncheckedGroups.push(g);
          }
        });
        if (selectableGroups.length === 0 && selectableServers.length === 0) {
          _this.state('notSelectable');
        } else if (uncheckedGroups.length === selectableGroups.length && selectedServers.length === 0) {
          _this.state('unchecked');
        } else if (checkedGroups.length === selectableGroups.length && selectedServers.length === selectableServers.length) {
          _this.state('checked');
        } else if (checkedGroups.length > 0 || selectedServers.length > 0) {
          _this.state('indeterminate');
        }
      };
    })(this));
  }

  return ServerPickerGroupViewModel;

})();

ServerPickerServerViewModel = (function() {
  function ServerPickerServerViewModel(server, options) {
    this.rawServer = server;
    this.displayName = ko.asObservable(this.rawServer.displayName != null ? this.rawServer.displayName : this.rawServer.name);
    this.isChecked = ko.observable(false);
    this.title = ko.computed((function(_this) {
      return function() {
        return options.getServerTitle(_this.rawServer);
      };
    })(this));
    this.selectable = ko.computed((function(_this) {
      return function() {
        return options.isServerSelectable(_this.rawServer);
      };
    })(this));
  }

  return ServerPickerServerViewModel;

})();

ServerPickerViewModel = (function() {
  function ServerPickerViewModel(options) {
    var _doesntMatter;
    options = options || {};
    this.defaultShouldShowGroup = function(group) {
      if (group.type != null) {
        return ko.unwrap(group.type) === 'default';
      } else {
        return true;
      }
    };
    this.defaultIsServerSelectable = function(server) {
      return true;
    };
    this.defaultGetServerTitle = function(server) {
      return server.description;
    };
    this.defaultGetGroupTitle = function(group) {
      return group.description;
    };
    this.defaultGetServerIcon = function(state) {
      state = ko.unwrap(state);
      if (state === 'archived') {
        return '#icon-question';
      } else if (state === 'queuedForArchive') {
        return '#icon-question';
      } else if (state === 'deleted') {
        return '#icon-question';
      } else if (state === 'queuedForDelete') {
        return '#icon-question';
      } else if (state === 'queuedForRestore') {
        return '#icon-question';
      } else if (state === 'underConstruction') {
        return '#icon-question';
      } else if (state === 'template') {
        return '#icon-queue';
      } else if (state === 'noDetails') {
        return '#icon-question';
      } else if (state === 'maintenanceMode') {
        return '#icon-maintenance';
      } else if (state === 'stopped') {
        return '#icon-stop';
      } else if (state === 'started') {
        return '#icon-play';
      } else if (state === 'paused') {
        return '#icon-pause';
      } else {
        return '#icon-question';
      }
    };
    this.allGroups = ko.asObservableArray(options.groups != null ? options.groups : []);
    this.isLoading = ko.asObservable(options.isLoading != null ? options.isLoading : false);
    this.loadingHtmlMessage = ko.asObservable(options.loadingHtmlMessage != null ? options.loadingHtmlMessage : 'Fetching Servers&hellip;');
    this.emptyHtmlMessage = ko.asObservable(options.emptyHtmlMessage != null ? options.emptyHtmlMessage : 'No Servers');
    this.selected = ko.asObservableArray(options.selectedServers);
    this.getServerIcon = options.getServerIcon != null ? options.getServerIcon : this.defaultGetServerIcon;
    this.shouldShowGroup = options.shouldShowGroup != null ? options.shouldShowGroup : this.defaultShouldShowGroup;
    this.isServerSelectable = options.isServerSelectable != null ? options.isServerSelectable : this.defaultIsServerSelectable;
    this.getServerTitle = options.getServerTitle != null ? options.getServerTitle : this.defaultGetServerTitle;
    this.getGroupTitle = options.getGroupTitle != null ? options.getGroupTitle : this.defaultGetGroupTitle;
    this.multiSelect = ko.asObservable(options.multiSelect != null ? options.multiSelect : true);
    this.templateName = ko.pureComputed((function(_this) {
      return function() {
        if (_this.multiSelect()) {
          return 'cyclops.serverPicker.group.multi';
        } else {
          return 'cyclops.serverPicker.group.single';
        }
      };
    })(this));
    this.groups = ko.computed((function(_this) {
      return function() {
        var filteredGroups;
        filteredGroups = _this.allGroups().filter(_this.shouldShowGroup);
        return filteredGroups.map(function(g) {
          return new ServerPickerGroupViewModel(g, {
            shouldShowGroup: _this.shouldShowGroup,
            getGroupTitle: _this.getGroupTitle,
            isServerSelectable: _this.isServerSelectable,
            getServerTitle: _this.getServerTitle,
            multiSelect: _this.multiSelect
          });
        });
      };
    })(this));
    this.groups().forEach((function(_this) {
      return function(g) {
        g.allServers().forEach(function(s) {
          if (_this.selected().indexOf(s.rawServer) > -1) {
            s.isChecked(true);
          }
        });
      };
    })(this));
    _doesntMatter = ko.computed((function(_this) {
      return function() {
        var checkedServers;
        if (!_this.multiSelect()) {
          return;
        }
        checkedServers = [];
        _this.groups().forEach(function(g) {
          checkedServers = checkedServers.concat(g.allServers().filter(function(s) {
            return s.isChecked();
          }));
        });
        checkedServers = checkedServers.map(function(s) {
          return s.rawServer;
        });
        _this.selected(checkedServers);
      };
    })(this));
    _doesntMatter.extend({
      rateLimit: 50
    });
  }

  return ServerPickerViewModel;

})();
